// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q2mB","colBig":"styles_colBig__1NI-D","colSmall":"styles_colSmall__9nfIe"};